// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.member-rol {
    overflow-y: auto;
    position: relative;
    background-color: var(--white-color);
}
.member-rol__data {
    display: flex;
    justify-content: center;
    margin: var(--space-and-half) 0 0 0;
}

.member-rol__roles__data-select{   
   display: flex;
   justify-content: center;
   padding-block-start: var(--space-x3);
}

.member-rol__roles  {
   width: 45%;
   margin-left: var(--space-and-half);
   margin-right: var(--space-and-half);
   margin-block-start: calc(var(--space)/6);
   font-size: var(--space-half-quarter);
   margin-bottom: 0px;
}

.member-rol .modal2__content {
    background: var(--white-color);
}

.member-rol__data__photo {
   border-radius: 50%;
   background-color: turquoise;
   width: calc((var(--space)/9)*27); /*52px*/
   height: calc((var(--space)/9)*27);
   margin: var(--space-quarter) var(--space-half-quarter) 0 0;
}

.member-rol__data__photo .icon-ball{
   color: var( --white-color );
   font-size: calc((var(--space-half))*6);/*48px;*/
   border-radius: 50%;
   padding: calc(var(--space)/4);/*4px;*/
}

.member-rol__data__photo__img {
    border-radius: 50%;
    width: calc((var(--space)/9)*27);
    height: calc((var(--space)/9)*27);

    
}

.member-rol__data__data {
    display: grid;
    justify-content: center;
}

.member-rol__data__data__name {
    font-size: var(--space-and-half);
}

.member-rol__data__data__username {
   color: var(--basic-gray-color);
   font-size: var(--space);
}



.end-tournament__form__elements{
    padding-top: var(--space-x2);
}

.member-rol__roles .select-field {
    margin: 0;
    border: 1px solid;
}

.member-rol__positions {
   margin-bottom: 0;
   display: flex;
   justify-content: center;
   grid-gap: 0 var(--space-and-half);
   
}

.member-rol__positions__number {
    width: 15%;
    margin-bottom: 0 !important;
}

.member-rol__positions__positions  {
    padding: var(--space-and-half) 0;
    width: 27%;
   
}

.member-rol__positions__positions .select-field {
   margin-bottom: 0px !important;
}

.member-rol__positions__number .input-field {
   margin-bottom: 0px !important;
}

.member-rol__positions__optional-label {
   margin-top: 0;
   padding: 0;
   font-size: calc((var(--space)/9)*6);
   color: var(--basic-gray-color);
   font-weight: 400;
   font-style: italic;
   line-height: calc((var(--space)/6)*5);
}

.member-rol__positions__button {
    display: flex;
    justify-content: center;
    padding-block-end: var(--space);
    
    margin-bottom: var(--space-half);
    margin-top: var(--space-x2);
}

.member-rol__positions__positions .MuiInputBase-input {
   padding: var(--space) ;
   
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-team-member-rol-modal/LeagueTeamMemberRolModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,oCAAoC;AACvC;;AAEA;GACG,UAAU;GACV,kCAAkC;GAClC,mCAAmC;GACnC,wCAAwC;GACxC,oCAAoC;GACpC,kBAAkB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;GACG,kBAAkB;GAClB,2BAA2B;GAC3B,gCAAgC,EAAE,OAAO;GACzC,iCAAiC;GACjC,0DAA0D;AAC7D;;AAEA;GACG,2BAA2B;GAC3B,sCAAsC,CAAC,QAAQ;GAC/C,kBAAkB;GAClB,6BAA6B,CAAC,OAAO;AACxC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,iCAAiC;;;AAGrC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;GACG,8BAA8B;GAC9B,uBAAuB;AAC1B;;;;AAIA;IACI,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;GACG,gBAAgB;GAChB,aAAa;GACb,uBAAuB;GACvB,iCAAiC;;AAEpC;;AAEA;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,UAAU;;AAEd;;AAEA;GACG,6BAA6B;AAChC;;AAEA;GACG,6BAA6B;AAChC;;AAEA;GACG,aAAa;GACb,UAAU;GACV,mCAAmC;GACnC,8BAA8B;GAC9B,gBAAgB;GAChB,kBAAkB;GAClB,qCAAqC;AACxC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,+BAA+B;;IAE/B,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;GACG,sBAAsB;;AAEzB","sourcesContent":["\n.member-rol {\n    overflow-y: auto;\n    position: relative;\n    background-color: var(--white-color);\n}\n.member-rol__data {\n    display: flex;\n    justify-content: center;\n    margin: var(--space-and-half) 0 0 0;\n}\n\n.member-rol__roles__data-select{   \n   display: flex;\n   justify-content: center;\n   padding-block-start: var(--space-x3);\n}\n\n.member-rol__roles  {\n   width: 45%;\n   margin-left: var(--space-and-half);\n   margin-right: var(--space-and-half);\n   margin-block-start: calc(var(--space)/6);\n   font-size: var(--space-half-quarter);\n   margin-bottom: 0px;\n}\n\n.member-rol .modal2__content {\n    background: var(--white-color);\n}\n\n.member-rol__data__photo {\n   border-radius: 50%;\n   background-color: turquoise;\n   width: calc((var(--space)/9)*27); /*52px*/\n   height: calc((var(--space)/9)*27);\n   margin: var(--space-quarter) var(--space-half-quarter) 0 0;\n}\n\n.member-rol__data__photo .icon-ball{\n   color: var( --white-color );\n   font-size: calc((var(--space-half))*6);/*48px;*/\n   border-radius: 50%;\n   padding: calc(var(--space)/4);/*4px;*/\n}\n\n.member-rol__data__photo__img {\n    border-radius: 50%;\n    width: calc((var(--space)/9)*27);\n    height: calc((var(--space)/9)*27);\n\n    \n}\n\n.member-rol__data__data {\n    display: grid;\n    justify-content: center;\n}\n\n.member-rol__data__data__name {\n    font-size: var(--space-and-half);\n}\n\n.member-rol__data__data__username {\n   color: var(--basic-gray-color);\n   font-size: var(--space);\n}\n\n\n\n.end-tournament__form__elements{\n    padding-top: var(--space-x2);\n}\n\n.member-rol__roles .select-field {\n    margin: 0;\n    border: 1px solid;\n}\n\n.member-rol__positions {\n   margin-bottom: 0;\n   display: flex;\n   justify-content: center;\n   grid-gap: 0 var(--space-and-half);\n   \n}\n\n.member-rol__positions__number {\n    width: 15%;\n    margin-bottom: 0 !important;\n}\n\n.member-rol__positions__positions  {\n    padding: var(--space-and-half) 0;\n    width: 27%;\n   \n}\n\n.member-rol__positions__positions .select-field {\n   margin-bottom: 0px !important;\n}\n\n.member-rol__positions__number .input-field {\n   margin-bottom: 0px !important;\n}\n\n.member-rol__positions__optional-label {\n   margin-top: 0;\n   padding: 0;\n   font-size: calc((var(--space)/9)*6);\n   color: var(--basic-gray-color);\n   font-weight: 400;\n   font-style: italic;\n   line-height: calc((var(--space)/6)*5);\n}\n\n.member-rol__positions__button {\n    display: flex;\n    justify-content: center;\n    padding-block-end: var(--space);\n    \n    margin-bottom: var(--space-half);\n    margin-top: var(--space-x2);\n}\n\n.member-rol__positions__positions .MuiInputBase-input {\n   padding: var(--space) ;\n   \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
